import Module from './Module';

const module = new Module('clientCards', '/api/v1/cards/friend');

export const {
  getById: getCardsById,
} = module;

export default module.reducer;



// WEBPACK FOOTER //
// ./src/modules/clientCards.js